import cookies from '../../libs/util.cookies'

/**
 * 合同催收中心 API 模块（写在微信端原程序内）
 * 财务接口 /financial/* 需要 appCode=YHGHT（axios 默认 WYPT 会被拒绝），
 * 因此这里走原生 fetch + Authorization: Bearer <we-chat-1.0.0-token>，
 * 完全复用微信端原程序登录态。
 */

const BASE = '/KYWB'
const APP_CODE = 'YHGHT'

export function getToken() {
  try {
    return cookies.get('token') || ''
  } catch (e) {
    return ''
  }
}

function ccApi(path, data) {
  const h = { 'Content-Type': 'application/json', 'appCode': APP_CODE }
  const tk = getToken()
  if (tk) h['Authorization'] = 'Bearer ' + tk
  return fetch(BASE + path, {
    method: 'POST',
    headers: h,
    body: data ? JSON.stringify(data) : '{}',
  })
    .then(r => r.json())
    .catch(() => ({ code: 999, message: '网络异常' }))
}

/** userList 后端为 GET 接口（POST 会 501），单独用 GET 调用 */
function ccApiGet(path, params) {
  const h = { 'Content-Type': 'application/json', 'appCode': APP_CODE }
  const tk = getToken()
  if (tk) h['Authorization'] = 'Bearer ' + tk
  const qs = params
    ? '?' + Object.keys(params).filter(k => params[k] != null).map(k => k + '=' + encodeURIComponent(params[k])).join('&')
    : ''
  return fetch(BASE + path + qs, {
    method: 'GET',
    headers: h,
  })
    .then(r => r.json())
    .catch(() => ({ code: 999, message: '网络异常' }))
}

function b64url(s) {
  let p = String(s).replace(/-/g, '+').replace(/_/g, '/')
  while (p.length % 4) p += '='
  return p
}

/** 解析当前登录用户（免登录复用微信端 cookie token） */
export function getMe() {
  const tk = getToken()
  if (!tk) return null
  let info = null
  try {
    const pay = String(tk).split('.')[1]
    if (pay) info = JSON.parse(decodeURIComponent(escape(atob(b64url(pay)))))
  } catch (e) {}
  return info
}

/* ============ 板块一：续签人 ============ */
export const loadAssignUsers = () => ccApiGet('/financial/contract/maintain/userList')
export const pageList = p => ccApi('/financial/contract/maintain/pageList', p)
export const assignUser = p => ccApi('/financial/contract/maintain/assignUser', p)
// 微信端更换签约人：提交变更申请，等待后台合同生成器第①步审核
export const assignChangeApply = p => ccApi('/financial/contract/maintain/assignChangeApply', p)
export const renewConfirm = p => ccApi('/financial/contract/maintain/renewConfirm', p)

/* ============ 板块二：催收 ============ */
export const recoverCenter = () => ccApi('/financial/financeCenter/recover')
export const arList = p => ccApi('/financial/financeCenter/ar/list', p)
export const createCase = p => ccApi('/financial/financeCenter/recover/case', p)
export const advanceCase = p => ccApi('/financial/financeCenter/recover/advance', p)
export const caseLogs = p => ccApi('/financial/financeCenter/recover/case/logs', p)
export const settleCase = p => ccApi('/financial/financeCenter/recover/settle', p)
export const collectAr = p => ccApi('/financial/financeCenter/ar/collect', p)

/* 8步催收流程 */
export const CC_FLOW = [
  ['到期提醒', '财务部', '陈会计'],
  ['电话催收', '财务部', '王出纳'],
  ['函件催收', '财务部', '陈会计'],
  ['上门催收', '财务部', '张经理'],
  ['停保警告', '运营部', '李主管'],
  ['法务介入', '法务部', '外聘法务'],
  ['折让分期', '老板办', '金时发'],
  ['结清核销', '财务部', '陈会计'],
]

// 图片 base64 上传（签回拍照）
export const uploadBase64 = p => ccApi('/foreign/storage/uploadFileByBase64', p)
